(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
const $ = window.jQuery

$(() => {
  $('.languagepicker-link').click(function(){
    $('.languagepicker').toggleClass('languagepicker--active');
    return false;
  });

  var ua = navigator.userAgent, event = (ua.match(/iPad/i)) ? "touchstart" : "click";
  $('html, body').on(event, function(e) {
    if($(e.target).closest('.languagepicker-box').length == 0) {
      $('.languagepicker').removeClass('languagepicker--active');
    }
  })
})

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/_languagepicker.js","/")